export default __webpack_public_path__ + "static/media/exp2.3c55bfe6.svg";